// src/actions/noteTypes.js

export const GET_NOTES = "GET_NOTES"
export const ADD_NOTE = "ADD_NOTE"
export const EDIT_NOTE = "EDIT_NOTE"
export const DELETE_NOTE = "DELETE_NOTE"
export const VIEW_NOTE = "VIEW_NOTE"
export const SET_LOADING = "SET_LOADING"
export const SET_FETCHING = "SET_FETCHING"
export const NOTE_ERROR = "NOTE_ERROR"
export const CLEAR_ERROR = "CLEAR_ERROR"
export const CRASH_ERROR = "CRASH_ERROR"
export const SET_SEARCH = "SET_SEARCH"
export const SET_FILTERS = "SET_FILTERS"
export const SET_SORTING = "SET_SORTING"
export const MODAL_RESET = "MODAL_RESET"
export const GLOBAL_RESET = "GLOBAL_RESET"